import { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useAuth } from 'react-oidc-context';
import {
  UserContext,
  handterSesjonsbrudd,
  medDirekteFornyelse,
} from '../../User/UserProvider.tsx';
import { sesjonsLogg, tokenInfo } from '../../User/sesjonsLogg';

// Felles for rutevaktene. Access token lever bare 10 minutter, og er det utløpt
// ved oppstart (omstart, dvale, F5) gir react-oidc-context isAuthenticated=false
// selv om refresh token ligger i lageret. Da fornyer vi først, og sender til
// OneLogin bare hvis refresh token er reelt dødt — ellers havner driftsskjermen
// i interaktiv innlogging hver gang OneLogin-økta har gått ut (ENK-29, §7).
// Når fornyelsen lykkes, gjør userLoaded at vakten rendrer siden i stedet.
const LoginRedirect = ({ vakt }) => {
  const user = useContext(UserContext);
  const auth = useAuth();

  useEffect(() => {
    const harRefreshToken = Boolean(auth.user?.refresh_token);
    sesjonsLogg(
      harRefreshToken ? 'rutevakt-fornyer' : 'rutevakt-sender-til-login',
      {
        vakt,
        sti: window.location.pathname,
        innlogget: user.isLoggedIn?.(),
        roller: user.getRoles?.(),
        token: tokenInfo(auth.user),
      }
    );
    if (harRefreshToken) {
      handterSesjonsbrudd(
        medDirekteFornyelse(auth),
        undefined,
        window.location.href
      );
      return;
    }
    user.login();
  }, []);

  return null;
};

LoginRedirect.propTypes = {
  vakt: PropTypes.string.isRequired,
};

export default LoginRedirect;
